export default __webpack_public_path__ + "static/media/sherif.ddad473d.jpg";